<template>
  <div class="rg-page">
    <!-- ===== ซ้าย: แผงสีน้ำเงิน ===== -->
    <aside class="rg-hero">
      <span class="rg-blob rg-blob--1"></span>
      <span class="rg-blob rg-blob--2"></span>

      <div class="rg-hero__inner">
        <h1 class="rg-hero__title">{{ lg_register.rg_hero_title }}</h1>
        <p class="rg-hero__sub">{{ lg_register.rg_hero_subtitle }}</p>

        <ul class="rg-feats">
          <li v-for="f in rgFeatures" :key="f.key">
            <span class="rg-feats__icon"><v-icon small color="#ffffff">{{ f.icon }}</v-icon></span>
            {{ lg_register[f.key] }}
          </li>
        </ul>
      </div>

      <p class="rg-hero__copy">{{ lg_register.rg_copyright }}</p>
    </aside>

    <!-- ===== ขวา: ฟอร์ม / OTP / สำเร็จ ===== -->
    <main class="rg-main">
      <!-- ส่งลิงก์สำเร็จ -->
      <div v-if="sendlinksuccess" class="rg-form rg-panel">
        <h2 class="rg-title">{{ this.lg_register.reset_title }}</h2>
        <p class="rg-sub">{{ this.lg_register.reset_subtitle1 }}</p>
        <p class="rg-sub">{{ this.lg_register.reset_subtitle2 }}</p>
        <p class="rg-sub">{{ this.lg_register.reset_subtitle3 }}</p>

        <button type="button" class="rg-btn rg-btn--primary mt-4" @click="onClickMenu('/login-account')">
          {{ this.lg_register.reset_btn }}
        </button>

        <p v-if="checklanguage == 'th'" class="rg-help">
          ต้องการความช่วยเหลือหรือไม่? หากท่านมีคำถามใดๆ กรุณา
          <span class="rg-link" @click="onClickMenu('/contact')">ติดต่อเรา</span>
        </p>
        <p v-else class="rg-help">
          Need help getting started?
          <span class="rg-link" @click="onClickMenu('/contact')"> Contact Support</span>
          if you have any questions.
        </p>
      </div>

      <!-- OTP Section - แสดงเมื่อ otpDlg = true -->
      <div v-else-if="otpDlg" class="rg-form rg-panel">
        <!-- Back button -->
        <button type="button" class="rg-back-btn" @click="cancelOtp">
          <v-icon size="20" color="#475569">mdi-chevron-left</v-icon>
        </button>

        <!-- Title v-bind:style="{ color: '#215295' }"-->
        <h2 class="rg-title otp-title">{{ this.lg_register.verify_email_title }}</h2>

        <!-- Subtitle -->
        <p class="rg-sub otp-subtitle">
          {{ this.lg_register.wesend_digit_code }} <strong>{{ maskEmail(account.username) }}</strong>.<br/>
          {{ this.lg_register.enter_finish_register }}
        </p>

        <!-- Label -->
        <div class="rg-label mt-4">
          <span class="otp-label">{{ this.lg_register.verification_code }}</span>
        </div>

        <!-- OTP Inputs -->
        <div class="rg-otp-row">
          <input
            v-for="(digit, index) in otpDigits"
            :key="'otp-' + index"
            :ref="'otp_' + index"
            v-model="otpDigits[index]"
            type="tel"
            maxlength="1"
            class="otp-box"
            @input="onOtpInput(index)"
            @keydown="onOtpKeydown($event, index)"
            @paste="onOtpPaste($event, index)"
          />
        </div>
        <div v-if="otpError" class="rg-err text-center">{{ otpError }}</div>

        <!-- Expire text -->
        <div class="otp-expire">
          {{ this.lg_register.code_expire }} {{ formattedTimeCode_Expire }} {{ this.lg_register.minutes }}
        </div>

        <!-- Verify Button -->
        <button
          type="button"
          class="rg-btn rg-btn--primary"
          :disabled="otpDigits.join('').length < 6 || btntoo_many_attempts || (totalSecondscode_expire <= 0)"
          @click="confirmOtp()"
        >
          {{ this.lg_register.verify }}
        </button>

        <!-- Resend -->
        <div class="otp-resend-wrapper">
          <span v-if="countdown > 0" class="otp-countdown">
            {{ this.lg_register.resend_code }} {{ countdown }} {{ this.lg_register.second }}
          </span>
          <button
            v-else
            type="button"
            class="rg-link-btn otp-resend"
            :disabled="btntoo_many_attempts"
            @click="handleResend()"
          >
            Resend Code
          </button>
        </div>
      </div>

      <!-- ฟอร์มสมัคร -->
      <!-- v-bind:style="{ color: '#215295' }" -->
      <form v-else class="rg-form" ref="form" novalidate @submit.prevent="submit">
        <h2 class="rg-title">{{ this.lg_register.title }}</h2>
        <p class="rg-sub">{{ this.lg_register.subtitle1 }}</p>

        <div class="rg-grid">
          <div>
            <label class="rg-label" for="rg-fname">{{ this.lg_register.txt_fname }}</label>
            <input
              id="rg-fname"
              v-model="account.acc_fname"
              type="text"
              class="rg-input"
              :class="{ 'rg-input--error': errors.acc_fname }"
              :placeholder="lg_register.rg_fname_placeholder"
            />
            <p v-if="errors.acc_fname" class="rg-err">{{ errors.acc_fname }}</p>
          </div>
          <div>
            <label class="rg-label" for="rg-lname">{{ this.lg_register.txt_lname }}</label>
            <input
              id="rg-lname"
              v-model="account.acc_lname"
              type="text"
              class="rg-input"
              :class="{ 'rg-input--error': errors.acc_lname }"
              :placeholder="lg_register.rg_lname_placeholder"
            />
            <p v-if="errors.acc_lname" class="rg-err">{{ errors.acc_lname }}</p>
          </div>
        </div>

        <label class="rg-label" for="rg-email">{{ this.lg_register.email }}</label>
        <input
          id="rg-email"
          v-model="account.username"
          type="email"
          class="rg-input"
          :class="{ 'rg-input--error': errors.username }"
          :placeholder="this.lg_register.email_place"
          autocomplete="username"
        />
        <p v-if="errors.username" class="rg-err">{{ errors.username }}</p>

        <label class="rg-label" for="rg-dob">{{ lg_register.dtp_birthday }}</label>
                  <!-- v-model="dateFormatted" -->
                  <!-- v-model="account.acc_birth" -->
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <div
              class="rg-input rg-datefield"
              :class="{ 'rg-input--error': errors.date }"
              v-bind="attrs"
              v-on="on"
            >
              <span :class="{ 'rg-placeholder': !date }">{{ dobDisplay || lg_register.rg_date_placeholder }}</span>
              <v-icon size="18" color="#64748b">mdi-calendar</v-icon>
            </div>
          </template>
          <v-date-picker
            v-model="date"
            no-title
            :max="maxBirthDate"
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
        <p v-if="errors.date" class="rg-err">{{ errors.date }}</p>

        <label class="rg-label" for="rg-pass">{{ this.lg_register.txt_password }}</label>
        <div class="rg-pass">
          <input
            id="rg-pass"
            v-model="account.password"
            :type="e1 ? 'password' : 'text'"
            class="rg-input"
            :class="{ 'rg-input--error': errors.password }"
            :placeholder="lg_register.rg_password_placeholder"
            autocomplete="new-password"
          />
          <button type="button" class="rg-eye" @click="e1 = !e1">
            <v-icon small color="#64748b">{{ e1 ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
          </button>
        </div>
        <p v-if="errors.password" class="rg-err">{{ errors.password }}</p>

        <label class="rg-label" for="rg-pass2">{{ this.lg_register.txt_password_confirm }}</label>
        <div class="rg-pass">
          <input
            id="rg-pass2"
            v-model="account.password_confirm"
            :type="e2 ? 'password' : 'text'"
            class="rg-input"
            :class="{ 'rg-input--error': errors.password_confirm }"
            :placeholder="lg_register.rg_confirm_placeholder"
            autocomplete="new-password"
          />
          <button type="button" class="rg-eye" @click="e2 = !e2">
            <v-icon small color="#64748b">{{ e2 ? 'mdi-eye-outline' : 'mdi-eye-off-outline' }}</v-icon>
          </button>
        </div>
        <p v-if="errors.password_confirm" class="rg-err">{{ errors.password_confirm }}</p>

            <!-- <v-divider></v-divider> -->
             <!-- <v-row>
           <v-col justify="center" align="center" cols="12">
        {{ this.lg_register.subtitle2 }}
        </v-col>
        </v-row> -->

        <label class="rg-agree">
          <input v-model="agree" type="checkbox" />
          <span v-if="checklanguage == 'th'">
            เมื่อดำเนินการต่อ คุณยอมรับ
            <span class="rg-link" @click.prevent="showPrivacyPolicy_1">{{ this.lg_footer.privacy_policy }}</span>
            และ
            <span class="rg-link" @click.prevent="showDmeetsdocx_4">{{ this.lg_footer.terms_and_conditions }}</span>
            ของ Dmeets
          </span>
          <span v-else>
            By proceeding, I agree to Dmeets’s
            <span class="rg-link" @click.prevent="showPrivacyPolicy_1">{{ this.lg_footer.privacy_policy }}</span>
            and
            <span class="rg-link" @click.prevent="showDmeetsdocx_4">{{ this.lg_footer.terms_and_conditions }}</span>
          </span>
        </label>

            <!-- <span>{{ account }}</span> -->
        <button
          type="submit"
          class="rg-btn rg-btn--primary"
          :disabled="btntoo_many_attempts || !agree"
        >
          {{ this.lg_register.btn_register }}
        </button>
              <!-- <v-btn @click.prevent="registerMember" color="success"
                >Register</v-btn
              > -->

        <p class="rg-signin">
          {{ this.lg_register.already_have_an_account }}
          <span class="rg-link" @click="onClickMenu('/login-account')">{{ this.lg_register.login_here }}</span>
        </p>
        <p class="rg-back">
          <span class="rg-link rg-link--muted" @click="onClickMenu('/')">&larr; {{ lg_register.rg_back_home }}</span>
        </p>
      </form>
    </main>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDlg" width="unset">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="alertDlg = false"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Alert Dialog -->

    <!-- Complete Dialog -->
    <v-dialog v-model="completeDlg" max-width="500">
      <v-card>
        <v-card-title class="headline">{{
          this.titleMessageAlert
        }}</v-card-title>

        <v-card-text class="body">
          {{ this.messageAlert }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            text
            @click="onclickcompleteDlg()"
            col="12"
            lg="12"
            md="12"
            sm="12"
          >
            Close
          </v-btn>

          <!-- <v-btn outlined color="error" text @click="confirmDelete">
            Confirm
          </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Complete Dialog -->

    <!-- OTP Dialog -->
<!-- <v-dialog v-model="otpDlg" persistent max-width="400">
  <v-card class="pa-4">
    <v-card-title class="justify-center text-h6 font-weight-bold">
      ยืนยัน OTP
    </v-card-title>
    <v-card-subtitle class="text-center mt-1">
      กรุณากรอกรหัส OTP 6 หลักที่ส่งไปยัง<br/>
      <strong>{{ account.username }}</strong>
    </v-card-subtitle>

    <v-card-text class="mt-4">
      <div class="d-flex justify-center" style="gap: 10px;">
        <v-text-field
          v-for="(digit, index) in otpDigits"
          :key="index"
          :ref="`otp_${index}`"
          v-model="otpDigits[index]"
          maxlength="1"
          outlined
          dense
          hide-details
          class="otp-input"
          style="max-width: 48px; text-align: center;"
          @input="onOtpInput(index)"
          @keydown="onOtpKeydown($event, index)"
          @paste="onOtpPaste($event)"
        />
      </div>
      <div v-if="otpError" class="red--text text-center mt-3 caption">
        {{ otpError }}
      </div>
    </v-card-text>

    <v-card-actions class="justify-center pb-4">
      <v-btn text color="grey" @click="cancelOtp">ยกเลิก</v-btn>
      <v-btn color="primary" :disabled="otpDigits.join('').length < 6" @click="confirmOtp">
        ยืนยัน
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog> -->

    <LoadingDialog></LoadingDialog>
  </div>
</template>

<script>
import api from "@/services/api";
import LoadingDialog from "@/components/cards/LoadingDialog";
import { server } from "../services/constants";
import { feature } from "../services/constants";
import { lg_register } from "./language/lg_register";
import { lg_footer } from "./language/lg_footer.js";

export default {
  data(vm) {
    // const d = new Date();
    // let nd = (d.getFullYear()+543) + "-" + (d.getMonth() + 1) + "-" + d.getDate();
    // alert(text);
    return {
      agree: false,
      errors: {
        acc_fname: "",
        acc_lname: "",
        username: "",
        date: "",
        password: "",
        password_confirm: "",
      },
      rgFeatures: [
        { key: "rg_feature1", icon: "mdi-check-circle-outline" },
        { key: "rg_feature2", icon: "mdi-account-group-outline" },
        { key: "rg_feature3", icon: "mdi-chart-box-outline" },
        { key: "rg_feature4", icon: "mdi-lock-outline" },
      ],
      countdownInterval: null,
      clickcountvaerify:0,
      btntoo_many_attempts:false,
      totalSecondscode_expire: 300,
      timercode_expire: null,
      otp_number:'',
      countdown: 45,
      timer: null,
      isPasting: false,
      otpDlg: false,
      otpDigits: ['', '', '', '', '', ''],
      otpError: '',
      otpResolve: null,
      sendlinksuccess:false,
      checklanguage:"",
      isRegister: false,
      alertDlg: false,
      completeDlg: false,
      myToggle: true,
      geust_id: "",
      geust_name: "",
      geust_ckeck: false,
      company_code: "",
      show_department: false,
      account: {
        username: "",
        password: "",
        password_confirm: "",
        company_id: 0,
        department_id: 10,
        acc_fname: "",
        acc_lname: "",
        acc_fullname: "",
        acc_id_card: "",
        acc_tel: "",
        acc_plan:"ENTERPRISE",
        acc_birth: null,
        role: "Member",
      },
      titleMessageAlert: "",
      messageAlert: "",
      date: vm.formatDateshowselect(new Date().toISOString().substr(0, 10)),
      dateFormatted: vm.formatDateshowselect(new Date().toISOString().substr(0, 10)),
      menu1: false,
      menu2: false,
      mDataArray: [],
      mDataArrayGuest: [],
      mDataArrayDepartment: [],
      valid: false,
      e1: true,
      e2: true,
      isShowPassword: false,
      commonRules: [(v1) => !!v1 || this.lg_register.rules_commond],
      passwordRules: [
        (v1) => !!v1 || this.lg_register.rules_password,
        (v2) =>
          !!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&^()=+/_-])[A-Za-z\d@$!%*?&^()=+/_-]{8,}$/.test(
            v2
          ) || this.lg_register.rules_password2,
      ],
      passwordConfirmRules: [
        (v1) =>
          this.account.password == this.account.password_confirm ||
          this.lg_register.rules_password_confirm,
      ],
      phoneRules: [(v1) => /^\d{10}$/.test(v1) || this.lg_register.rules_phone],
      codeRules:"",
      emailRules: [
        (v1) =>
          /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
            v1
          ) || this.lg_register.rules_email,
      ],
      dateOfBirthRules: [
  (v1) => {
    const today = new Date();
    const dob = new Date(this.date); 
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age >= 18 || this.lg_register.validatedate_of_birth;
  },
],
    };
  },

  beforeCreate() {
    this.$store.state.page_reload = false;

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_register = lg_register.register_th)
      : (this.lg_register = lg_register.register_en);


    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_footer = lg_footer.lg_footer_th)
      : (this.lg_footer = lg_footer.lg_footer_en);
      

    // console.log("lg_register: " + JSON.stringify(this.lg_register));
  },

  computed: {
    // แสดงวันเกิดเป็น วัน/เดือน/ปี
    dobDisplay() {
      if (!this.date) return "";
      const parts = String(this.date).split("-");
      if (parts.length !== 3) return "";
      return parts[2] + "/" + parts[1] + "/" + parts[0];
    },
    // เลือกได้ไม่เกินวันนี้
    maxBirthDate() {
      return new Date().toISOString().substr(0, 10);
    },
     formattedTimeCode_Expire() {
      const minutes = Math.floor(this.totalSecondscode_expire / 60)
      const seconds = this.totalSecondscode_expire % 60

      return `${minutes}:${seconds.toString().padStart(2, '0')}`
    },
    widthcard() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return "width:80%";
        case "sm":
          return "width:70%";
        case "md":
          return "width:70%";
        case "lg":
          return "width:60%";
        case "xl":
          return "width:50%";
      }
    },
    buttonsmall() {
      if (this.$vuetify.breakpoint.name === "xs") {
        return true;
      }
    },
    computedDateFormatted() {
      return this.formatDate(this.date);
    },
  },
  components: {
    LoadingDialog,
  },
  async mounted() {
    this.$store.state.loadFooter = false;
    // alert(new Date(1772004047378).toLocaleString());
    //  alert(new Date(Date.now()).toLocaleString());
    const userId = localStorage.getItem(server.USER_ID);
       if (userId && api.isLoggedIn()) {
      this.$router.push("/listroom");
      return;
    }
    this.checklanguage = localStorage.getItem(feature.LANGUAGE);
    localStorage.setItem(server.MEET_STA, "false");
    this.loadGuest();
    this.loadCompany();
    clearInterval(this.timercode_expire);
    clearInterval(this.timer);
    this.checkDisableStatus();
  },

  watch: {
    date(val) {
      this.dateFormatted = this.formatDate(this.date);
    },
  },
  methods: {
    // ===== ตรวจฟอร์มเอง (แทน $refs.form.validate ของ v-form) =====
    runRules(rules, value) {
      for (const rule of rules) {
        const res = rule(value);
        if (res !== true) return res;
      }
      return "";
    },
    validateForm() {
      this.errors.acc_fname = this.runRules(this.commonRules, this.account.acc_fname);
      this.errors.acc_lname = this.runRules(this.commonRules, this.account.acc_lname);
      this.errors.username = this.runRules(this.emailRules, this.account.username);
      this.errors.date = !this.date
        ? this.lg_register.rg_invalid_date
        : this.runRules(this.dateOfBirthRules, this.dateFormatted);
      this.errors.password = this.runRules(this.passwordRules, this.account.password);
      this.errors.password_confirm = this.runRules(this.passwordConfirmRules, this.account.password_confirm);
      return !Object.keys(this.errors).some((k) => this.errors[k]);
    },
   async triggerDisable() {
      const expireTime = Date.now() + (5 * 60 * 1000) // 5 นาที
      sessionStorage.setItem('register_disable_expire', expireTime);

      this.btntoo_many_attempts = true;
      await this.startCountdowntoo_many_attempts();
    },

 async checkDisableStatus() {
  const expireTime = Number(sessionStorage.getItem('register_disable_expire'));

  if (!expireTime) return;

  if (Date.now() < expireTime) {
    this.btntoo_many_attempts = true;
   await this.startCountdowntoo_many_attempts();
  } else {
   await this.clearDisable();
  }
},

async startCountdowntoo_many_attempts() {
  clearInterval(this.countdownInterval)

  this.countdownInterval = setInterval(async() => {
    const expireTime = Number(sessionStorage.getItem('register_disable_expire'))

    if (!expireTime || Date.now() >= expireTime) {
     await this.clearDisable();
    }
  }, 1000)
},

   async clearDisable() {
  this.btntoo_many_attempts = false;
  sessionStorage.removeItem('register_disable_expire');
  clearInterval(this.countdownInterval);
  this.countdownInterval = null;
},
     maskEmail(email) {
    if (!email) return ''

    const [name, domain] = email.split('@')
    if (!name || !domain) return email

    if (name.length <= 2) {
      return name[0] + '*@' + domain
    }

    return (
      name[0] +
      '*'.repeat(name.length - 2) +
      name[name.length - 1] +
      '@' +
      domain
    )
  },
     startCountdownCode_Expire() {
       this.clearTimerCode_Expire();
      this.totalSecondscode_expire = 300;
      this.timercode_expire = setInterval(() => {
        if (this.totalSecondscode_expire > 0) {
          this.totalSecondscode_expire--
        } else {
        this.clearTimerCode_Expire();
        }
      }, 1000)
    },
     clearTimerCode_Expire() {
      // if (this.timercode_expire) {
        clearInterval(this.timercode_expire)
        this.timercode_expire = null
      // }
    },
    startCountdown() {
       this.clearTimer();
      this.countdown = 45;
      this.clearTimer();
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.clearTimer();
        }
      }, 1000)
    },
    clearTimer() {
      // if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      // }
    },
   async handleResend() {
      // TODO: เรียก API ส่ง OTP ที่นี่
      this.$emit('resend');
     await this.openOtpDialog();
    },
async openOtpDialog() {
  this.$store.state.loadMenu=true;
  this.clickcountvaerify = 0;
  this.otpDigits = ['', '', '', '', '', ''];
  this.otpError = '';

     const result = await api.sendMailforVerifyaccount(this.account);
     if(result.status === 200 || result.status === 201){
      // result.data
      this.otp_number = result.data.otp_number;
this.$swal.close(); 
   
  this.otpDlg = true;
  this.startCountdown();
  this.startCountdownCode_Expire();

  this.$nextTick(() => {
    setTimeout(() => {
      const firstEmpty = this.otpDigits.findIndex(d => !d);
      const index = firstEmpty !== -1 ? firstEmpty : 0;
      this.focusInput(index);
    }, 200); 
  });
  this.$store.state.loadMenu=false;
  return new Promise((resolve) => {
    this.otpResolve = resolve;
  });
    }else{
  this.$store.state.loadMenu=false;
  this.$swal.close(); 
  this.titleMessageAlert = "Send Email";
  this.messageAlert =  "Send Email Fail!!";
  this.completeDlg = true;
    }
},

focusFirstEmpty() {
  const firstEmpty = this.otpDigits.findIndex(d => !d);
  const index = firstEmpty !== -1 ? firstEmpty : 0;

  const input = this.$refs['otp_' + index];
  if (input && input[0]) {
    input[0].focus();
    input[0].select();
  }
},
onFocus(index) {
  this.focusInput(index);
},
onOtpInput(index) {
  let val = this.otpDigits[index] || ''
  val = val.replace(/\D/g, '').slice(-1)

  this.$set(this.otpDigits, index, val)

  if (val && index < 5) {
    this.focusInput(index + 1)
  }

},
focusInput(index) {
  this.$nextTick(() => {
    const ref = this.$refs['otp_' + index];
    const el = Array.isArray(ref) ? ref[0] : ref;
    if (el) el.focus();
  });
},

onOtpKeydown(event, index) {
  if (event.key === 'Backspace') {

    if (!this.otpDigits[index] && index > 0) {
      this.focusInput(index - 1);
    } else {
      this.$set(this.otpDigits, index, '');
    }

  }
},

onOtpPaste(event, index) {
  event.preventDefault();
  this.isPasting = true;

  const pasteData = (event.clipboardData || window.Clipboard)
    .getData('text')
    .trim()
    .replace(/\D/g, '')
    .slice(0, 6)

  if (!pasteData) return

  this.otpDigits = ['', '', '', '', '', '']

  this.$nextTick(() => {
    for (let i = 0; i < 6; i++) {
      const ref = this.$refs['otp_' + i]
      const el = Array.isArray(ref) ? ref[0] : ref
      if (el) el.value = ''
    }

    const newDigits = ['', '', '', '', '', '']
    pasteData.split('').forEach((digit, i) => {
      const targetIndex = index + i
      if (targetIndex < newDigits.length) {
        newDigits[targetIndex] = digit
      }
    })

    this.otpDigits = newDigits

    this.$nextTick(() => {
      for (let i = 0; i < 6; i++) {
        const ref = this.$refs['otp_' + i]
        const el = Array.isArray(ref) ? ref[0] : ref
        if (el) el.value = this.otpDigits[i]
      }

      const lastFilledIndex = Math.min(index + pasteData.length - 1, this.otpDigits.length - 1)
      const ref = this.$refs['otp_' + lastFilledIndex]
      const el = Array.isArray(ref) ? ref[0] : ref
      if (el) el.focus()
       this.isPasting = false;
    })
     this.isPasting = false;
  })
},


async confirmOtp() {
  const otp = this.otpDigits.join('');
  //   console.log(otp);
  //  console.log(this.otp_number);
  //  console.log(this.totalSecondscode_expire);
  if (otp.length < 6) {
    this.otpError = `${this.lg_register.pls_enter_full_digit}`;
    return;
  }
  
  if(this.totalSecondscode_expire == 0){
  this.otpError = `${this.lg_register.code_expire_pls_resend}`;
    return;
  }
  
  if(otp == this.otp_number){
    this.clickcountvaerify = 0;
    this.$store.state.loadMenu = true;
  // this.otpDlg = false;
  if (this.otpResolve) this.otpResolve({ confirmed: true, otp });
   }else if(this.clickcountvaerify >= 5){
    this.otpError = `${this.lg_register.too_many_attempts}`;
    this.btntoo_many_attempts = true;
    await this.triggerDisable();
    this.clickcountvaerify = 0;
    return;
    
   }
   else{
    this.clickcountvaerify++;
    this.otpError = `${this.lg_register.incorrect_code}`;
    return;
   }
  
},

cancelOtp() {
  this.otpDlg = false;
  this.sendlinksuccess = false;
  if (this.otpResolve) this.otpResolve({ confirmed: false, otp: '' });
},
    onChangeDTP() {
      // alert(this.value);
    },
    async checkCompany() {
      if(this.company_code.length > 0) {
      //    this.codeRules = [
      //   (v1) =>
      //     /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/.test(v1) ||
      //     this.lg_register.rules_code,
      // ];
    this.codeRules = [
        (v1) =>
          /^(?=.*[A-Za-z])[A-Za-z\d]{6,}$/.test(v1) ||
          this.lg_register.rules_code,
      ];
      }
      
      
      // alert("checkCompany");
      // console.log("checkCompany:" + JSON.stringify(this.mDataArray));
      // console.log("checkCompany company_code:" + this.company_code);
      const result_code = await api.checkByCompanyCode(this.company_code);
      // console.log("checkCompany company_code:" + JSON.stringify(result_code));
      if (result_code.data != null) {
        // alert("Company:" + result_code.data.id);
        this.account.company_id = result_code.data.id;
        this.account.acc_plan = "PREMIUM";
        this.account.role = "Member";
        this.show_department = true;
        this.loadDepartment(result_code.data.id);
      } else {
        // alert("null");
        this.account.acc_plan = "ENTERPRISE";
        this.account.role = "Member";
        this.account.company_id = this.geust_id;
        this.show_department = false;
      }
      // this.mDataArray.forEach((element) => {
      //   if (element.company_code == this.company_code) {
      //     // alert("Company:" + element.id);
      //     this.account.company_id = element.id;
      //     this.account.role = "Member";
      //     this.show_department = true;
      //     this.loadDepartment(element.id);
      //   }
      // });
      // if (this.account.company_id == 0) {
      //   this.account.role = "Guest";
      //   this.account.company_id = this.geust_id;
      //   this.show_department = false;
      // }
      // console.log("checkCompany company_code:" + this.account.company_id);
    },
    changeDepartment(selectObj) {
      // console.log(selectObj);
      // alert(selectObj);
      this.account.department_id = selectObj;
    },
    async changeCompany(selectObj) {
      // console.log(selectObj)
      this.loadDepartment(selectObj);
    },
    async loadDepartment(id) {
      // console.log("loadDepartment")
      let result = await api.getAllDepartmentByCompanyId(id);
      // console.log(result)
      this.mDataArrayDepartment = result.data;
      // console.log(JSON.stringify(result.data));
    },
    async loadGuest() {
      this.mDataArrayGuest = [];

      let result = await api.getCompanyGuestId();
      // console.log("loadGuest : " + JSON.stringify(result.data));
      this.mDataArrayGuest = result.data.rows;

      // console.log("loadGuest : " + this.mDataArrayGuest[0].id);
      // console.log("loadGuest : " + this.mDataArrayGuest[0].company_name);
      // console.log("loadGuest2 : " + JSON.stringify(result.data.id));
      this.geust_id = this.mDataArrayGuest[0].id;
      this.geust_name = this.mDataArrayGuest[0].company_name;
      this.department_id = 10;
    },
    onChangeToggle() {
      if (this.myToggle == true) {
        this.account.role = "Member";
      } else {
        this.account.role = "Member";
        this.account.company_id = this.geust_id;
      }
      // alert(this.myToggle);
      // alert(this.account.role);
    },
    onclickcompleteDlg() {
      this.completeDlg = false;
      this.$router.push("/");
    },
    async submit() {
      //Code_DCM
  //     console.log(this.date);
  // console.log(this.dateFormatted);
      // console.log("submitCompany :" + JSON.stringify(this.account));

      if (this.validateForm()) {
        this.account.acc_fullname = `${this.account.acc_fname}  ${this.account.acc_lname}`;
        this.$store.state.loadMenu = true;
        // this.$swal.showLoading();

        this.titleMessageAlert = this.lg_register.dialog_check_data;

        // alert(this.company_code.length); 
        // if (this.company_code.length != 6 && this.company_code.length > 0) {
        //   this.messageAlert = this.lg_register.dialog_company_code;
        //   this.alertDlg = true;
        //   this.$store.state.loadMenu = false;
        //   return;
        // }

        const result = await api.checkRegister(this.account.username);
       
        // alert(JSON.stringify(result.data));
        if (result.data != null) {
          this.messageAlert = this.lg_register.dialog_email_used;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }
        this.account.acc_birth = this.date;
        // alert(JSON.stringify(this.account));
        // if (this.account.company_id == 0 && this.account.role == "Member") {
        //   this.messageAlert = "กรุณาเลือกบริษัท";
        //   this.alertDlg = true;
        //   this.$store.state.loadMenu = false;
        //   return;
        // }

        if (this.account.username == "") {
          this.messageAlert = this.lg_register.dialog_empty_email;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

        if (this.account.password == "") {
          this.messageAlert = this.lg_register.dialog_empty_password;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

        if (this.account.password != this.account.password_confirm) {
          this.messageAlert = this.lg_register.dialog_empty_password_confirm;
          this.alertDlg = true;
          this.$store.state.loadMenu = false;
          this.$swal.close(); 
          return;
        }

   this.$store.state.loadMenu=false;
  const otpResult = await this.openOtpDialog();

  if (!otpResult.confirmed) {
    this.$swal.close(); 
    this.$store.state.loadMenu = false;
    return; 
  }
  

  
  // return;
  // this.$swal.showLoading();

        const result_resister = await api.register(this.account);
        this.$swal.close();
        // alert(JSON.stringify(result_resister));
        if (result_resister != null) {
          // alert("result_resister.data != null");
          this.isRegister = true;
          // this.titleMessageAlert = this.lg_register.dialog_save;
          // this.messageAlert = this.lg_register.dialog_save_success;
          // this.completeDlg = true;
            this.otpDlg = false;
           this.sendlinksuccess = true;
          // this.$router.push("/");
          this.$store.state.loadMenu = false;
          // this.$store.dispatch({
          //                           type: 'doLogin',
          //                           username: this.account.username,
          //                           password: this.account.password,
          //                           rememberme:false,
          //                         }).then((data) => {
          //                                   this.$store.state.loadMenu = false;
          //                                   if(data==false){
          //                                     this.$router.push("/login-account").catch(()=>{});
          //                                   }
          //                         });
        } else {
          // alert("result_resister.data == null");
          this.titleMessageAlert = this.lg_register.dialog_save;
          this.messageAlert = this.lg_register.dialog_save_fail;
          this.$store.state.loadMenu = false;
        }
      }
    },
    async loadCompany() {
      let result = await api.getCompanyNotGuest();
      this.mDataArray = result.data;
      // console.log(JSON.stringify(result.data));
    },
    formatDate(date) {
      if (!date) return null;

      // const [year, month, day] = date.split("-");
      // return `${day}-${month}-${parseInt(year)+0}`;
        const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
    formatDateshowselect(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
    parseDate(date) {
      if (!date) return null;

      // const [day, month, year] = date.split("/");
      // return `${day.padStart(2,'0')}-${month.padStart(2,'0')}-${year}`;
       const [year, month, day] = date.split("-");
      return `${parseInt(year)+0}-${month}-${day}`;
    },
       showPrivacyPolicy_1() {
      window.open(`http://${window.location.host}/privacy-policy`);
    },
    showDmeetsdocx_4() {
       if(this.checklanguage == "th"){
       window.open(`http://${window.location.host}/DCM_Terms_and_Conditions_(TH).pdf`);
      }else{
       window.open(`http://${window.location.host}/DCM_Terms_and_conditions_(ENG).pdf`);
      }
    },
     onClickMenu(link) {
      this.$router.push(link).catch((err) => {});
    },
  },
};
</script>

<style>
.v-progress-circular {
  margin: 1rem;
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: rgb(59, 163, 236);
  color: white;
  border-radius: 16px;
  padding: 20px 20px 20px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: rgb(59, 163, 236);
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  box-shadow: 0 5px 30px rgba(black, 0.1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

@media (min-width: 960px) {
  .register-container {
    margin-top: 2rem
  }
}
.otp-box {
  width: 48px;
  height: 56px;
  border: 2px solid #bbb;
  border-radius: 12px;
  text-align: center;
  font-size: 1.4rem;
  font-weight: 600;
  color: #1a1a2e;
  outline: none;
  transition: border-color 0.2s;
  background: #fff;
}

.otp-box:focus {
  border-color: #1867c0; /* สีฟ้า Vuetify */
  border-width: 2px;
}
.custom-disabled.v-btn.v-btn--disabled {
  background-color: #9e9e9e !important;
  color: #ffffff !important;
  opacity: 1 !important; /* กัน Vuetify ลดความจาง */
}


/* ===================== UI ใหม่ (register) ===================== */
.rg-page {
  display: flex;
  min-height: calc(100vh - 70px);
  background: #ffffff;
  font-family: inherit;
  color: #0f172a;
}

/* ---------- ซ้าย ---------- */
.rg-hero {
  position: relative;
  flex: 1 1 50%;
  background: #3b6cb0;
  color: #ffffff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 48px;
}
.rg-blob { position: absolute; border-radius: 50%; background: rgba(255, 255, 255, 0.08); pointer-events: none; }
.rg-blob--1 { width: 640px; height: 640px; top: -280px; left: -160px; }
.rg-blob--2 { width: 760px; height: 760px; bottom: -320px; right: -200px; }
.rg-hero__inner { position: relative; max-width: 440px; }
.rg-hero__title { font-size: 34px; line-height: 1.35; font-weight: 700; white-space: pre-line; margin: 0 0 18px; }
.rg-hero__sub { font-size: 16px; line-height: 1.7; color: rgba(255, 255, 255, 0.88); white-space: pre-line; margin: 0 0 36px; }
.rg-feats { list-style: none; padding: 0; margin: 0; }
.rg-feats li { display: flex; align-items: center; gap: 12px; font-size: 14px; margin-bottom: 18px; }
.rg-feats__icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.15);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rg-hero__copy { position: absolute; left: 48px; bottom: 36px; margin: 0; font-size: 12px; color: #c7dbf5; }

/* ---------- ขวา ---------- */
.rg-main {
  flex: 1 1 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
}
.rg-form { width: 100%; max-width: 384px; position: relative; }
.rg-panel { text-align: center; }
.rg-title { font-size: 24px; font-weight: 700; margin: 0 0 6px; }
.rg-sub { font-size: 14px; color: #64748b; margin: 0 0 20px; }
.rg-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }

.rg-label { display: block; font-size: 14px; font-weight: 500; color: #0f172a; margin: 14px 0 6px; }
.rg-grid .rg-label { margin-top: 0; }
.rg-input {
  width: 100%;
  height: 42px;
  padding: 0 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  font: inherit;
  font-size: 14px;
  color: #0f172a;
  background: #ffffff;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.rg-input::placeholder { color: #94a3b8; }
.rg-input:focus { border-color: #215295; box-shadow: 0 0 0 3px rgba(33, 82, 149, 0.15); }
.rg-input--error { border-color: #dc2626; }
.rg-err { font-size: 12px; color: #dc2626; margin: 6px 0 0; }
.rg-datefield {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  cursor: pointer;
}
.rg-placeholder { color: #94a3b8; }
.rg-pass { position: relative; }
.rg-pass .rg-input { padding-right: 42px; }
.rg-eye { position: absolute; right: 8px; top: 50%; transform: translateY(-50%); background: none; border: 0; padding: 4px; cursor: pointer; }

.rg-agree {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 20px 0;
  font-size: 13px;
  line-height: 1.6;
  color: #334155;
  cursor: pointer;
}
.rg-agree input { width: 16px; height: 16px; margin-top: 3px; accent-color: #215295; cursor: pointer; flex-shrink: 0; }
.rg-link { color: #215295; font-weight: 600; text-decoration: none; cursor: pointer; }
.rg-link:hover { text-decoration: underline; }
.rg-link--muted { color: #94a3b8; font-weight: 400; font-size: 12px; }

.rg-btn {
  width: 100%;
  height: 44px;
  border: 0;
  border-radius: 8px;
  font: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.rg-btn--primary { background: #215295; color: #ffffff; }
.rg-btn--primary:hover:not(:disabled) { background: #1a4278; }
.rg-btn--primary:disabled { background: #9db4d4; cursor: default; }

.rg-signin { text-align: center; font-size: 14px; color: #64748b; margin: 24px 0 0; }
.rg-back { text-align: center; margin: 18px 0 0; }
.rg-help { font-size: 13px; color: #64748b; margin-top: 20px; }

/* OTP */
.rg-back-btn {
  position: absolute;
  top: -8px;
  left: -8px;
  width: 34px;
  height: 34px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.rg-otp-row { display: flex; justify-content: center; gap: 10px; margin: 10px 0 14px; }
.otp-expire { font-size: 12px; color: #64748b; text-align: left; margin-bottom: 16px; }
.otp-resend-wrapper { margin-top: 14px; font-size: 13px; color: #64748b; }
.rg-link-btn { background: none; border: 0; color: #215295; font: inherit; font-weight: 600; cursor: pointer; }
.rg-link-btn:disabled { color: #94a3b8; cursor: default; }

/* ---------- Responsive ---------- */
@media (max-width: 959px) {
  .rg-hero { display: none; }
  .rg-main { padding: 32px 20px; align-items: flex-start; }
}
@media (max-width: 599px) {
  .rg-grid { grid-template-columns: 1fr; }
  .rg-otp-row { gap: 6px; }
  .otp-box { width: 42px; height: 50px; }
}

</style>